import produce from 'immer'
import { combineReducers } from 'redux'
import {
  getAllCarriersAction,
  getCarrierAction,
} from '../actions/carriersActions'

const byId = (state = {}, action) =>
  produce(state, draft => {
    const { type, payload } = action

    switch (type) {
      case getAllCarriersAction.SUCCESS:
        payload.items.forEach(carrier => {
          draft[carrier.id] = carrier
        })
        break
    }
  })

const visibleIds = (state = [], action) =>
  produce(state, draft => {
    switch (action.type) {
      case getAllCarriersAction.SUCCESS:
        draft.splice(
          0,
          draft.length,
          ...action.payload.items.map(carrier => carrier.id)
        )
        break
    }
  })

const meta = (state = {}, action) =>
  produce(state, draft => {
    switch (action.type) {
      case getAllCarriersAction.SUCCESS:
        Object.assign(draft, action.payload.meta)
        break
    }
  })

// replaced rather than merged, so switching between carriers never
// leaves the previous one's fields behind
const current = (state = {}, action) => {
  switch (action.type) {
    case getCarrierAction.SUCCESS:
      return action.payload
    default:
      return state
  }
}

const carriersReducer = combineReducers({
  byId,
  visibleIds,
  current,
  meta,
})

const getCarrier = (state, id) => state.byId[id]
const getCurrentCarrier = state => state.current
const getVisibleCarriers = state =>
  state.visibleIds.map(id => getCarrier(state, id))
const getCarriersMeta = state => state.meta

export {
  carriersReducer as default,
  getCurrentCarrier,
  getVisibleCarriers,
  getCarriersMeta,
}
